import React from 'react';
import { Search, Bell, User } from 'lucide-react';
export function Nav() {
  return <nav className="sticky top-0 z-50 w-full bg-black/80 backdrop-blur-md border-b border-white/5" data-id="element-47">
      <div className="max-w-[1600px] mx-auto px-6 h-16 flex items-center justify-between" data-id="element-48">
        <div className="flex items-center gap-8" data-id="element-49">
          <a href="#" className="text-2xl font-serif italic text-rose-500 tracking-wide" data-id="element-50">
            Animeverse
          </a>
          <div className="hidden md:flex items-center gap-6 text-sm font-medium text-white/60" data-id="element-51">
            <a href="#" className="text-white hover:text-rose-400 transition-colors" data-id="element-52">
              Discover
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              Library
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-54">
              Seasonal
            </a>
          </div>
        </div>

        <div className="flex items-center gap-5 text-white/70" data-id="element-55">
          <button className="hover:text-white transition-colors" data-id="element-56">
            <Search className="w-5 h-5" data-id="element-57" />
          </button>
          <button className="hover:text-white transition-colors relative" data-id="element-58">
            <Bell className="w-5 h-5" data-id="element-59" />
            <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border border-black" data-id="element-60"></span>
          </button>
          <button className="w-8 h-8 rounded-full bg-dark border border-white/10 overflow-hidden hover:border-rose-500/50 transition-colors" data-id="element-61">
            <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=100&auto=format&fit=crop" alt="Avatar" className="w-full h-full object-cover" data-id="element-62" />
          </button>
        </div>
      </div>
    </nav>;
}